/* Estelle's Closet — Collection toolbar (Filter / Sort / Grid toggle) */
(function () {
  'use strict';

  var GRID_STORAGE_KEY = 'ec_collection_grid_v1';

  function initFilterButton() {
    var btn = document.querySelector('[data-ec-ctb-filter]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      // Trigger the existing <menu-drawer><details><summary> to open the
      // native filter drawer Shopify's facets.js already wires up.
      var summary = document.querySelector('.mobile-facets__wrapper summary');
      if (summary) summary.click();
    });
  }

  function initSortDrawer() {
    var sortBtn = document.querySelector('[data-ec-ctb-sort]');
    var sort = document.querySelector('[data-ec-sort]');
    if (!sortBtn || !sort) return;

    function open() {
      sort.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      sort.hidden = true;
      document.body.style.overflow = '';
    }

    sortBtn.addEventListener('click', open);
    sort.querySelectorAll('[data-ec-sort-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!sort.hidden && e.key === 'Escape') close();
    });

    // Submit form on radio change — Shopify facets.js intercepts via
    // facet-filters-form, but our sort form is standalone so we submit directly.
    var form = sort.querySelector('[data-ec-sort-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'sort_by') {
          // Merge current URL params so active filters survive the sort
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', e.target.value);
          window.location.search = params.toString();
        }
      });
    }
  }

  function applyGrid(cols) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.remove('ec-grid-1', 'ec-grid-2');
      grid.classList.add('ec-grid-' + cols);
    }
    // Also tag the body so CSS can hide unrelated UI when 1-col is active
    document.body.classList.remove('ec-grid-1', 'ec-grid-2');
    document.body.classList.add('ec-grid-' + cols);

    document.querySelectorAll('[data-ec-ctb-grid]').forEach(function (btn) {
      btn.classList.toggle(
        'ec-ctb__grid-btn--active',
        btn.getAttribute('data-ec-ctb-grid') === String(cols)
      );
    });
  }

  function initGridToggle() {
    var saved = null;
    try { saved = localStorage.getItem(GRID_STORAGE_KEY); } catch (e) {}
    applyGrid(saved === '1' ? 1 : 2);

    document.querySelectorAll('[data-ec-ctb-grid]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-ec-ctb-grid');
        applyGrid(cols);
        try { localStorage.setItem(GRID_STORAGE_KEY, cols); } catch (e) {}
      });
    });
  }

  function init() {
    initFilterButton();
    initSortDrawer();
    initGridToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
